import React, { useState } from 'react';
import { Box, Typography, Button, Container, Grid, useTheme, useMediaQuery, InputAdornment, TextField, IconButton } from '@mui/material';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import PartnersTable from '../components/PartnersTable';
import PartnerFormDrawer from '../components/PartnerFormDrawer';
interface PartnersProps {
  onLogout: () => void;
}
const Partners: React.FC<PartnersProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [partnerDrawerOpen, setPartnerDrawerOpen] = useState(false);
  const [editPartner, setEditPartner] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleAddPartner = () => {
    setEditPartner(null);
    setPartnerDrawerOpen(true);
  };
  const handleEditPartner = (partner: any) => {
    setEditPartner(partner);
    setPartnerDrawerOpen(true);
  };
  const handleClosePartnerDrawer = () => {
    setPartnerDrawerOpen(false);
    setEditPartner(null);
  };
  const handleSavePartner = (partnerData: any) => {
    // In a real app, this would save the partner data to the backend
    console.log('Save partner', partnerData);
    setPartnerDrawerOpen(false);
    // Show success toast (would be implemented with a toast library)
  };
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };
  const clearSearch = () => {
    setSearchQuery('');
  };
  const handleManageUsers = (partnerId: string) => {
    // Use React Router navigation instead of window.location.href
    navigate(`/partner-users?partner=${partnerId}`);
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC'
  }} data-id="element-4713">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-4714" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="partners" data-id="element-4715" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        sm: `calc(100% - ${240}px)`
      },
      ml: 0,
      mt: 8
    }} data-id="element-4716">
        <Container maxWidth="xl" data-id="element-4717">
          {/* Header */}
          <Grid container spacing={2} alignItems="center" sx={{
          mb: 3
        }} data-id="element-4718">
            <Grid item xs={12} md={6} data-id="element-4719">
              <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }} data-id="element-4720">
                <Icon icon="lucide:building" width={24} height={24} color="#0EA5E9" data-id="element-4721" />
                <Typography variant="h5" component="h1" sx={{
                ml: 1.5,
                fontWeight: 600
              }} data-id="element-4722">
                  Partners
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} data-id="element-4723">
              <Box sx={{
              display: 'flex',
              gap: 2,
              flexWrap: 'wrap',
              justifyContent: {
                xs: 'flex-start',
                md: 'flex-end'
              }
            }} data-id="element-4724">
                <Button variant="contained" startIcon={<Icon icon="lucide:plus" width={18} height={18} data-id="element-4726" />} onClick={handleAddPartner} data-id="element-4725">
                  Add Partner
                </Button>
              </Box>
            </Grid>
          </Grid>
          {/* Partners Table */}
          <PartnersTable onEditPartner={handleEditPartner} onManageUsers={handleManageUsers} searchQuery={searchQuery} data-id="element-4727" />
          {/* Partner Form Drawer */}
          <PartnerFormDrawer open={partnerDrawerOpen} partner={editPartner} onClose={handleClosePartnerDrawer} onSave={handleSavePartner} data-id="element-4728" />
        </Container>
      </Box>
    </Box>;
};
export default Partners;